export const retryCodes = [-32602];
